// src/data/products.js

export const products = [
  {
    id: "columnas-metalicas",
    name: "Columnas Metálicas",
    shortDescription:
      "Columnas metálicas telescópicas y octogonales de 7 a 16 metros para alumbrado público, señalización vial y aplicaciones industriales según normas internacionales.",
    description:
      "METSIM Solutions fabrica columnas metálicas telescópicas y octogonales de 7, 9, 10, 12, 14 y 16 metros de altura, diseñadas para alumbrado público, señalización vial y soporte industrial. Cada columna es calculada estructuralmente con software de simulación avanzado (SolidWorks), garantizando cumplimiento con normas IEC, ITAIPÚ y ANDE. Ofrecemos columnas troncocónicas, cilíndricas y octogonales en acero galvanizado o con recubrimiento epoxi.",
    category: "Alumbrado y Señalización",
    badge: "Norma IEC",
    icon: "🏗️",
    keywords: [
      "columnas metálicas Paraguay",
      "postes metálicos Asunción",
      "columnas telescópicas Paraguay",
      "columnas octogonales Paraguay",
      "columnas para alumbrado público",
      "columnas de acero Paraguay",
      "postes de iluminación 7 9 10 12 14 16 metros",
    ],
    metaDescription:
      "Fabricación de columnas metálicas telescópicas y octogonales de 7 a 16m en Paraguay. METSIM Solutions produce columnas para alumbrado público, señalización y uso industrial con cálculo estructural y normas IEC.",
    specs: [
      { label: "Material", value: "Acero A36" },
      { label: "Altura disponible", value: "7m, 9m, 10m, 12m, 14m, 16m" },
      { label: "Tipo", value: "Telescópica / Octogonal / Troncocónica" },
      { label: "Acabado", value: "Galvanizado en caliente / Pintura epoxi" },
      { label: "Norma", value: "EETT 03.10.18 y 03.10.19" },
      { label: "Cálculo", value: "Simulación estructural SolidWorks" },
    ],
    applications: [
      "Alumbrado público urbano y rural",
      "Señalización vial y cartelería",
      "Industria y plantas de producción",
      "Estadios y espacios deportivos",
      "Redes eléctricas de distribución",
    ],
    models: [
      { src: "/models/columna-metalica.glb", label: "Columna Metálica" },
    ],
    modelPoster: null,
  },
  {
    id: "brazos-alumbrado",
    name: "Brazos de Alumbrado Público",
    shortDescription:
      "Brazos metálicos para postes de alumbrado público diseñados según norma, con simulación estructural avanzada.",
    description:
      "Fabricamos brazos porta-luminaria para alumbrado público en simple y doble brazo, adaptados a diferentes tipos de columnas y luminarias LED. Cada pieza es diseñada en SolidWorks y validada estructuralmente para soportar viento, peso y vibración según normativa nacional e internacional. Entregamos con todos los accesorios de montaje.",
    category: "Alumbrado y Señalización",
    badge: "Doble brazo disponible",
    icon: "💡",
    keywords: [
      "brazos de alumbrado público Paraguay",
      "brazos metálicos para postes",
      "porta luminarias Paraguay",
      "brazos alumbrado LED Asunción",
      "brazo metálico para columna",
    ],
    metaDescription:
      "Brazos de alumbrado público en Paraguay. METSIM fabrica brazos metálicos para postes de luz según norma, en simple y doble brazo, con todos los accesorios de montaje incluidos.",
    specs: [
      { label: "Material", value: "Acero estructural / Aluminio" },
      { label: "Longitud", value: "2m – 3m (personalizable)" },
      { label: "Tipo", value: "Simple brazo / Doble brazo / Ornamental" },
      { label: "Acabado", value: "Galvanizado / Pintura polvo" },
      { label: "Compatibilidad", value: "Luminarias LED, sodio, vapor de mercurio" },
      { label: "Montaje", value: "Incluye pernos y accesorios" },
    ],
    applications: [
      "Alumbrado de calles y avenidas",
      "Alumbrado de rutas nacionales",
      "Parques y plazas públicas",
      "Proyectos MOPC / Municipalidades",
      "Zonas industriales y logísticas",
    ],
    models: [
      { src: "/models/brazo-alumbrado-2m.glb", label: "Brazo 2m" },
      { src: "/models/brazo-alumbrado-3m.glb", label: "Brazo 3m" },
      { src: "/models/petalo-3-hojas.glb", label: "Pétalo 3 Hojas" },
    ],
    modelPoster: null,
  },
  {
    id: "estructuras-metalicas",
    name: "Estructuras Metálicas",
    shortDescription:
      "Diseño y fabricación de estructuras metálicas en Paraguay: galpones industriales, naves de acero, entrepisos y cobertizos con cálculo estructural AISC, planos y montaje incluido.",
    description:
      "METSIM Solutions diseña y fabrica estructuras metálicas industriales para proyectos en todo Paraguay. Somos especialistas en galpones metálicos, naves industriales, entrepisos estructurales y cobertizos de acero, con planta de fabricación propia y entrega e instalación en Asunción y todo el interior del país.\n\nCada proyecto de estructura metálica incluye cálculo estructural con simulación en SolidWorks, planos de fabricación y montaje firmados por ingeniero matriculado, fabricación con acero A36 y A572 Gr50, montaje con equipo técnico especializado y cumplimiento de normas AISC 360 y CIRSOC.\n\nFabricamos desde pequeñas estructuras metálicas hasta galpones con luz libre de hasta 60 metros sin columnas intermedias. Cubiertas en chapa acanalada galvanizada, panel sándwich térmico o policarbonato. Trabajamos para industria logística, agroindustria, sector comercial e infraestructura pública en Paraguay.",
    category: "Construcción Industrial",
    badge: "Norma AISC",
    icon: "🏭",
    keywords: [
      "estructuras metálicas Paraguay",
      "galpones metálicos Paraguay",
      "naves industriales acero Paraguay",
      "construcción metálica Paraguay",
      "galpones prefabricados Paraguay",
      "entrepiso metálico Paraguay",
      "fabricante estructuras metálicas Paraguay",
      "construcción galpones industriales Asunción",
      "precio estructura metálica Paraguay",
      "cobertizo metálico Paraguay",
      "nave industrial acero Asunción",
      "estructura metálica galpón Paraguay",
    ],
    metaDescription:
      "Estructuras metálicas en Paraguay. METSIM fabrica galpones, naves industriales y entrepisos de acero en Asunción con cálculo AISC, planos y montaje incluido. Cotizá gratis en 24 hs.",
    faq: [
      {
        q: "¿Cuánto cuesta fabricar una estructura metálica en Paraguay?",
        a: "El costo depende de las dimensiones, tipo de acero, cubierta y acabados requeridos. METSIM ofrece cotización detallada sin cargo en 24 horas, con cálculo estructural preliminar y planos de referencia incluidos.",
      },
      {
        q: "¿Cuánto tiempo tarda en fabricarse un galpón metálico?",
        a: "Para proyectos estándar, el plazo típico es de 6 a 12 semanas desde la aprobación del diseño hasta la entrega montada. Proyectos de mayor envergadura se acuerdan según cronograma con el cliente.",
      },
      {
        q: "¿Los planos son aptos para gestión de permisos municipales en Paraguay?",
        a: "Sí. Cada proyecto de estructura metálica incluye planos de fabricación y estructura firmados por ingeniero matriculado, aptos para la gestión de permisos municipales en Paraguay.",
      },
      {
        q: "¿Fabrican estructuras metálicas en todo Paraguay o solo en Asunción?",
        a: "METSIM fabrica en planta propia y entrega e instala en todo el territorio paraguayo: Asunción, Gran Asunción, departamentos del interior y proyectos en la región del Chaco.",
      },
    ],
    specs: [
      { label: "Material", value: "Acero A36 / A572 Gr50" },
      { label: "Norma de diseño", value: "AISC 360 / CIRSOC" },
      { label: "Luz máxima", value: "Hasta 60m sin columnas intermedias" },
      { label: "Altura", value: "Personalizable según proyecto" },
      { label: "Cubierta", value: "Chapa acanalada, sandwich, policarbonato" },
      { label: "Entrega", value: "Incluye planos, fabricación y montaje" },
    ],
    applications: [
      "Galpones industriales y logísticos",
      "Naves de producción y almacenaje",
      "Entrepisos metálicos estructurales",
      "Cobertizos y estacionamientos",
      "Estructuras para agroindustria",
      "Edificios comerciales e institucionales",
    ],
    models: [
      { src: "/models/nave-industrial.glb", label: "Nave Industrial" },
      { src: "/models/estructura-metalica-entrepiso.glb", label: "Entrepiso Metálico" },
    ],
    softwareImage: {
      src: "https://res.cloudinary.com/dk6wclcew/image/upload/v1775394343/metsim/quotes/g0f9ki8ouxpvfg7ygr4z.png",
      alt: "Cálculo estructural con SolidWorks — METSIM Solutions",
    },
    modelPoster: null,
  },
  {
    id: "techos-metalicos",
    name: "Techos Metálicos",
    shortDescription:
      "Techos metálicos en Paraguay: tinglados parabólicos, techos a dos aguas y a un agua para galpones, cocheras, quinchos, canchas y comercios. Cálculo de viento, planos y montaje incluidos.",
    description:
      "METSIM Solutions diseña, fabrica y monta techos metálicos en todo Paraguay: tinglados parabólicos, techos a dos aguas y a un agua para galpones, cocheras, quinchos, canchas deportivas, depósitos, comercios y viviendas. Cada techo sale de nuestra planta en Caacupé con la estructura calculada para el lugar donde se instala, no copiada de una tabla genérica.\n\nEl cálculo es lo que separa un techo que dura de uno que se vuela en el primer temporal. Dimensionamos cerchas, vigas y correas según AISC 360 y CIRSOC, y verificamos la acción del viento con la norma paraguaya NP 30:1-001, teniendo en cuenta la ubicación, la altura y la forma de la cubierta. Las bases y los anclajes se dimensionan con esas mismas cargas, porque es ahí donde fallan la mayoría de los techos improvisados.\n\nLa estructura se fabrica en acero A36, con tubo estructural o perfiles laminados y correas de perfil C galvanizado. La cubierta se elige según el uso:\n\n• Chapa trapezoidal o acanalada galvanizada: la opción más económica y rápida para tinglados, depósitos y cocheras.\n• Chapa prepintada: la misma estructura, con color y mejor terminación para comercios y viviendas.\n• Panel sándwich (termopanel): chapa con aislación térmica y acústica para quinchos, oficinas y depósitos que necesitan temperatura estable.\n• Policarbonato o chapas traslúcidas: franjas de luz natural que reducen el uso de iluminación durante el día.\n\nEntregamos el techo terminado: relevamiento en obra, cálculo y planos firmados por ingeniero matriculado, fabricación en planta propia, transporte y montaje con equipo especializado. Los planos sirven para la gestión de permisos municipales.\n\nPedí tu cotización sin cargo: con las medidas aproximadas y la ubicación del techo te enviamos una propuesta con el tipo de estructura, la cubierta recomendada y el plazo de entrega.",
    category: "Construcción Industrial",
    badge: "Cálculo de viento",
    icon: "🏠",
    keywords: [
      "techos metálicos Paraguay",
      "techo metálico precio Paraguay",
      "tinglado metálico",
      "tinglado parabólico Paraguay",
      "techo parabólico",
      "techo de chapa",
      "techo para cochera",
      "quincho techo metálico",
      "panel sándwich techo",
      "cobertizo metálico",
      "techo para galpón",
      "techos metálicos Caacupé",
    ],
    metaDescription:
      "Techos metálicos en Paraguay: tinglados parabólicos, cocheras y quinchos con chapa o panel sándwich. Cálculo de viento y montaje incluidos. Cotizá gratis.",
    faq: [
      {
        q: "¿Cuánto cuesta un techo metálico en Paraguay?",
        a: "Depende de la superficie, la forma (parabólico, a dos aguas o a un agua), la altura y el tipo de cubierta: chapa galvanizada, prepintada o panel sándwich. METSIM envía una cotización detallada sin cargo en 24 horas, con el tipo de estructura recomendado y el plazo de entrega.",
      },
      {
        q: "¿Qué conviene más, chapa o panel sándwich?",
        a: "La chapa galvanizada es la opción más económica y rápida, ideal para tinglados, cocheras y depósitos. El panel sándwich cuesta más pero aísla del calor y del ruido, por eso conviene en quinchos, oficinas, viviendas y depósitos que necesitan temperatura estable.",
      },
      {
        q: "¿Un techo metálico resiste los temporales?",
        a: "Sí, si está calculado. METSIM verifica la acción del viento según la norma paraguaya NP 30:1-001 y dimensiona la estructura, las correas y los anclajes con esas cargas. En los techos que se vuelan, lo que suele fallar son los anclajes o las uniones de las correas, no la chapa.",
      },
      {
        q: "¿Hacen el montaje? ¿En qué zonas trabajan?",
        a: "Sí. Fabricamos en nuestra planta de Caacupé y montamos con equipo propio en todo Paraguay: Asunción y Gran Asunción, Central, Cordillera y el interior del país.",
      },
    ],
    specs: [
      { label: "Estructura", value: "Acero A36 · tubo estructural o perfil laminado" },
      { label: "Correas", value: "Perfil C galvanizado" },
      { label: "Cubierta", value: "Chapa galvanizada, prepintada o panel sándwich" },
      { label: "Formas", value: "Parabólico, dos aguas, un agua" },
      { label: "Cálculo de viento", value: "NP 30:1-001 (norma paraguaya)" },
      { label: "Norma de diseño", value: "AISC 360 / CIRSOC" },
    ],
    applications: [
      "Tinglados para canchas y escuelas",
      "Cocheras y estacionamientos techados",
      "Quinchos y áreas de eventos",
      "Galpones agrícolas y depósitos",
      "Techos para comercios y viviendas",
      "Cobertizos para maquinaria",
    ],
    // Sin fotos ni modelo 3D todavia: la ficha muestra "Disponible proximamente".
    // Lo primero a sumar son fotos de obras reales.
    models: [],
    softwareImage: null,
    modelPoster: null,
  },
  {
    id: "tanques-metalicos",
    name: "Tanques Metálicos",
    shortDescription:
      "Fabricación de tanques metálicos para almacenamiento de agua, combustibles y líquidos industriales con certificación.",
    description:
      "Diseñamos y fabricamos tanques metálicos a medida para almacenamiento de agua potable, combustibles, aceites y líquidos industriales. Cada tanque es calculado según norma API 650, ASME o requerimiento del cliente, con control de calidad en cada etapa de producción. Disponibles en acero al carbono, inoxidable y con revestimiento interno según el fluido.",
    category: "Almacenamiento Industrial",
    badge: "Norma API 650",
    icon: "🛢️",
    keywords: [
      "tanques metálicos Paraguay",
      "tanques de almacenamiento acero",
      "depósitos metálicos industriales",
      "tanques combustible Paraguay",
      "tanques agua acero inoxidable",
    ],
    metaDescription:
      "Tanques metálicos en Paraguay. METSIM fabrica tanques de almacenamiento de agua, combustibles y líquidos industriales según norma API 650 y ASME, con control de calidad.",
    specs: [
      { label: "Material", value: "Acero al carbono / Inoxidable 304-316" },
      { label: "Norma", value: "API 650 / ASME VIII / EN 13121" },
      { label: "Capacidad", value: "500 litros – 500.000 litros" },
      { label: "Fluidos", value: "Agua, combustibles, aceites, químicos" },
      { label: "Instalación", value: "Aéreo, semienterrado, enterrado" },
      { label: "Acabado", value: "Pintura epoxi / Revestimiento interno" },
    ],
    applications: [
      "Almacenamiento de agua potable e industrial",
      "Depósitos de combustible (nafta, gasoil, GLP)",
      "Reservorios para riego agrícola",
      "Industria alimentaria y farmacéutica",
      "Plantas de tratamiento de agua",
    ],
    models: [],
    modelPoster: null,
  },
  {
    id: "tamiz-rotativo",
    name: "Tamiz Rotativo de Finos",
    shortDescription:
      "Fabricación de tamices rotativos (trommel) para clasificación y separación de materiales finos en industria minera, agrícola y ambiental.",
    description:
      "Función:\n• Filtración o tamizado de sólidos (separación sólido-líquido).\n• Eliminación de sólidos finos con tamaño mayores.\n• Autolimpiante.\n\nLos pretratamientos están diseñados principalmente para aguas residuales urbanas típicas. Para vertidos industriales u otros usos.\n\nCaracterísticas:\n• Fabricado en acero inoxidable AISI 304, con cilindro filtrante en AISI 304, motor reductor 400 V 50 Hz, incluido válvula de mariposa, electroválvulas agua de red. Tomas bridadas fabricadas en AISI 304 o roscable.\n\nAccesorios:\n• Electroválvula para el paso de agua de limpieza.\n• Filtro Y.\n• Válvula de bola.",
    category: "Tratamiento de Aguas",
    badge: "Autolimpiante",
    icon: "⚙️",
    keywords: [
      "tamiz rotativo Paraguay",
      "tamiz autolimpiante aguas residuales",
      "pretratamiento aguas residuales Paraguay",
      "tamiz inoxidable AISI 304",
      "separador sólidos líquidos Paraguay",
    ],
    metaDescription:
      "Tamiz rotativo autolimpiante en Paraguay. METSIM fabrica tamices en acero inoxidable AISI 304 para pretratamiento de aguas residuales urbanas e industriales. Cotizá en 24 horas.",
    specs: [
      { label: "Material", value: "AISI 304 / AISI 316" },
      { label: "Diámetro", value: "250 – 1000 mm" },
      { label: "Longitud", value: "Personalizable" },
      { label: "Apertura de malla", value: "3 – 20 mm" },
      { label: "Accionamiento", value: "Motor eléctrico + reductor" },
    ],
    applications: [
      "Pretratamiento de aguas residuales urbanas",
      "Tratamiento de vertidos industriales",
      "Separación sólido-líquido",
      "Filtración de sólidos en línea",
      "Plantas de tratamiento de agua potable",
    ],
    models: [
      { src: "/models/tamiz-rotativo.glb", label: "Vista 3D" },
    ],
    images: [
      { src: "/images/tamiz/tamiz-1.jpg", label: "Tamiz Rotativo — METSIM Solutions" },
      { src: "/images/tamiz/tamiz-2.jpg", label: "Tamiz Rotativo — detalle constructivo" },
      { src: "/images/tamiz/tamiz-3.jpg", label: "Tamiz Rotativo — montaje en planta" },
      { src: "/images/tamiz/tamiz-4.jpg", label: "Tamiz Rotativo — instalación completa" },
    ],
    modelPoster: null,
  },
  {
    id: "soporte-panel-solar",
    name: "Soporte de Panel Solar y Batería",
    shortDescription:
      "Estructuras metálicas para soporte de paneles solares y baterías, diseñadas para instalaciones de iluminación autónoma y sistemas de energía solar.",
    description:
      "METSIM fabrica soportes metálicos estructurales para paneles solares y baterías, utilizados en sistemas de iluminación solar autónoma, telecomunicaciones y generación de energía off-grid. Diseñados con acero galvanizado de alta resistencia y calculados para soportar cargas de viento según normativa local. Compatible con paneles solares de hasta 400W y baterías de ciclo profundo.",
    category: "Energía Solar",
    badge: "Sistema autónomo",
    icon: "☀️",
    keywords: [
      "soporte panel solar Paraguay",
      "estructura panel solar metálica",
      "soporte batería solar Paraguay",
      "iluminación solar Paraguay",
      "energía solar off-grid Paraguay",
    ],
    metaDescription:
      "Soportes metálicos para paneles solares y baterías en Paraguay. METSIM fabrica estructuras galvanizadas para sistemas de iluminación solar autónoma y energía off-grid.",
    specs: [
      { label: "Material", value: "Acero galvanizado en caliente" },
      { label: "Compatibilidad", value: "Paneles hasta 400W / Baterías ciclo profundo" },
      { label: "Acabado", value: "Galvanizado / Pintura anticorrosiva" },
      { label: "Inclinación panel", value: "Ajustable según latitud" },
      { label: "Cálculo", value: "Estructural para carga de viento" },
      { label: "Entrega", value: "Incluye accesorios de montaje" },
    ],
    applications: [
      "Iluminación solar autónoma en rutas",
      "Sistemas de telecomunicaciones off-grid",
      "Alumbrado de zonas rurales sin red eléctrica",
      "Cámaras de seguridad solar",
      "Señalización vial solar",
    ],
    models: [
      { src: "/models/soporte-panel-solar.glb", label: "Soporte Panel Solar" },
    ],
    modelPoster: null,
  },
  {
    id: "flotador-aire-disuelto",
    name: "Flotador por Aire Disuelto (DAF)",
    shortDescription:
      "Sistema DAF para tratamiento de aguas residuales industriales con floculador tubular y mezclador estático integrados.",
    description:
      "El Flotador por Aire Disuelto (DAF) de METSIM es un sistema de tratamiento de aguas residuales industriales que separa sólidos suspendidos, grasas y aceites mediante microburbujas de aire. Fabricado en acero al carbono A36 con recubrimiento en pintura epoxi de alta resistencia química. El sistema integra un floculador tubular y un mezclador estático para optimizar el proceso de coagulación-floculación previo a la flotación. Incluye sistema de tamizado previo en acero inoxidable AISI 304.",
    category: "Tratamiento de Aguas",
    badge: "Sistema integrado DAF",
    icon: "💧",
    keywords: [
      "flotador aire disuelto Paraguay",
      "DAF tratamiento aguas residuales",
      "sistema DAF Paraguay",
      "tratamiento aguas industriales Paraguay",
      "flotación aire disuelto",
      "floculador tubular Paraguay",
    ],
    metaDescription:
      "Sistema Flotador por Aire Disuelto (DAF) en Paraguay. METSIM fabrica equipos DAF para tratamiento de aguas residuales industriales con floculador tubular y mezclador estático integrado.",
    specs: [
      { label: "Material principal", value: "Acero al carbono A36" },
      { label: "Recubrimiento", value: "Pintura epoxi alta resistencia química" },
      { label: "Sistema de bombeo", value: "Bombas sumergibles para aguas residuales" },
      { label: "Sistema de aireación", value: "Compresor de aire disuelto" },
      { label: "Pre-tratamiento", value: "Tamiz en Acero Inoxidable AISI 304, malla 3mm" },
      { label: "Accesorios incluidos", value: "Floculador tubular + Mezclador estático" },
    ],
    applications: [
      "Tratamiento de efluentes industriales",
      "Plantas de tratamiento de agua potable",
      "Industria alimentaria y frigorífica",
      "Industria textil y papelera",
      "Efluentes con alta carga de grasas y aceites",
    ],
    models: [
      { src: "/models/daf-5m3h.glb", label: "Vista Isométrica", staticView: true, cameraOrbit: "25deg 68deg auto" },
      { src: "/models/daf-5m3h.glb", label: "Vista Superior",   staticView: true, cameraOrbit: "0deg 8deg auto" },
    ],
    images: [
      { src: "/images/daf/DAF-0.jpg", label: "DAF 5 m³/h — METSIM Solutions" },
      { src: "/images/daf/DAF-1.jpg", label: "DAF — Sistema completo instalado" },
      { src: "/images/daf/DAF-2.jpg", label: "DAF — Vista lateral" },
      { src: "/images/daf/DAF-3.jpg", label: "DAF — Detalle de construcción" },
      { src: "/images/daf/DAF-4.jpg", label: "DAF — Montaje en planta" },
      { src: "/images/daf/DAF-5.jpg", label: "DAF — Instalación completa" },
    ],
    pdfSrc: "/docs/DAF-Layout5.pdf",
    modelPoster: null,
  },
  {
    id: "floculador-tubular",
    name: "Floculador Tubular",
    shortDescription:
      "Reactor de floculación de flujo forzado para tratamiento de agua potable e industrial. Sin partes móviles, 3 puntos de inyección integrados. Fabricación e instalación a nivel nacional según requerimientos del cliente.",
    description:
      "El Floculador Tubular METSIM es un reactor de flujo forzado que homogeneiza y dosifica productos químicos —coagulantes, floculantes, reguladores de pH, oxidantes— directamente en la línea de tratamiento de agua. La energía de mezcla se genera por turbulencias forzadas en los giros, constricciones y ampliaciones de la tubería, sin necesidad de agitadores eléctricos ni partes móviles. Cada unidad integra 3 puntos de inyección para una dosificación química instantánea y precisa. Diseño compacto sin zonas muertas ni retromezclado, con excelentes propiedades de crecimiento uniforme del flóculo. Fabricamos e instalamos en todo el territorio nacional, desde modelos DN63 hasta DN250, adaptados al caudal y requerimientos específicos de cada proyecto. Tiempo de respuesta y cotización en 24 horas.",
    category: "Tratamiento de Aguas",
    badge: "Sin partes móviles",
    icon: "🌀",
    keywords: [
      "floculador tubular Paraguay",
      "floculación agua potable Paraguay",
      "reactor floculación hidráulica",
      "equipo tratamiento agua Paraguay",
      "floculador PVC acero inoxidable",
      "planta potabilizadora Paraguay",
    ],
    metaDescription:
      "Floculador tubular en Paraguay. METSIM fabrica e instala reactores de floculación de flujo forzado para agua potable e industrial, desde DN63 hasta DN250, sin partes móviles. Cotizá en 24 horas.",
    specs: [
      { label: "Material tubería", value: "PVC PN10 resistente a químicos" },
      { label: "Estructura soporte", value: "Galvanizado o acero inoxidable (según modelo)" },
      { label: "Puntos de inyección", value: "3 integrados por unidad" },
      { label: "Pérdida de presión", value: "< 0,2 bar" },
      { label: "Partes móviles", value: "Ninguna — mantenimiento mínimo" },
      { label: "Modelos METSIM", value: "DN63 (8–12 m³/h) a DN250 (180–250 m³/h)" },
      { label: "Dimensiones", value: "Largo aprox. 3.200–4.000 mm (según modelo)" },
      { label: "Fabricación", value: "A medida según caudal del proyecto" },
    ],
    applications: [
      "Plantas de agua potable",
      "Aguas industriales y efluentes",
      "Pre-tratamiento para flotadores DAF",
      "Pre-tratamiento para decantadores",
      "Rotura de emulsiones por coagulación",
      "Dosificación de oxidantes y desinfectantes",
    ],
    models: [],
    images: [
      { src: "/images/floculadores/floculador-tubular-1.jpeg", label: "Floculador Tubular — METSIM Solutions" },
      { src: "/images/floculadores/floculador-tubular-2.jpeg", label: "Floculador Tubular — detalle de construcción" },
      { src: "/images/floculadores/floculador-tubular-3.jpeg", label: "Floculador Tubular — montaje en planta" },
      { src: "/images/floculadores/floculador-tubular-4.png", label: "Floculador Tubular — instalación completa" },
    ],
    modelPoster: null,
  },
  {
    id: "mezclador-estatico",
    name: "Mezclador Estático",
    shortDescription:
      "Mezcladores estáticos inline con elementos helicoidales para mezcla radial y axial de reactivos químicos en tuberías. Sin partes móviles, cero consumo eléctrico. Fabricación e instalación a nivel nacional.",
    description:
      "El Mezclador Estático METSIM es un dispositivo inline que genera mezcla continua y homogénea de fluidos mediante láminas guía helicoidales estacionarias. El fluido es cortado y forzado contra las paredes opuestas de la tubería, creando vórtices alternados de rotación inversa que garantizan una mezcla radial y axial completa con baja caída de presión. Sin partes móviles, sin consumo eléctrico —la energía de mezcla proviene únicamente del fluido bombeado. Disponible con elemento fijo o desmontable según la aplicación. Fabricamos e instalamos en todo el territorio nacional en diámetros desde 3/4\" hasta 6\" (DN20 a DN150), en cuerpo de acero inoxidable AISI 304 o PVC sch80, con conexiones bridadas o roscadas. Cotización en 24 horas.",
    category: "Tratamiento de Aguas",
    badge: "Cero consumo eléctrico",
    icon: "🔄",
    keywords: [
      "mezclador estático Paraguay",
      "mezclador inline acero inoxidable",
      "dosificación química agua Paraguay",
      "mezclador estático tratamiento agua",
      "mezcla reactivos sin partes moviles",
      "mezclador tubería Paraguay",
    ],
    metaDescription:
      "Mezcladores estáticos en Paraguay. METSIM fabrica e instala mezcladores inline en acero inoxidable AISI 304 o PVC para dosificación de reactivos, cloración y control de pH. Sin partes móviles.",
    specs: [
      { label: "Material cuerpo", value: "Acero inoxidable AISI 304 / PVC sch80" },
      { label: "Material elementos", value: "Acero inoxidable AISI 304" },
      { label: "Diámetros disponibles", value: "3/4\" a 6\" (DN20 a DN150)" },
      { label: "Cantidad de elementos", value: "6 elementos mezcladores por unidad" },
      { label: "Conexión", value: "Bridada / Roscada (según diámetro)" },
      { label: "Caudal referencial", value: "4–9 g/min (3/4\") hasta 260–580 g/min (6\")" },
      { label: "Partes móviles", value: "Ninguna — virtualmente libre de mantenimiento" },
      { label: "Elemento desmontable", value: "Disponible según requerimiento" },
    ],
    applications: [
      "Dosificación de coagulantes y floculantes",
      "Cloración y ozonización en línea",
      "Dilución de polímeros y aditivos",
      "Control y corrección de pH",
      "Pre-mezcla para sistemas DAF",
      "Industria química, alimentaria y farmacéutica",
    ],
    models: [
      { src: "/models/mezclador-estatico.glb", label: "Vista 3D" },
    ],
    images: [
      { src: "/images/mezcladores/mezclador-estatico-1.png", label: "Mezclador Estático — METSIM Solutions" },
      { src: "/images/mezcladores/mezclador-estatico-2.jpeg", label: "Mezclador Estático — detalle constructivo" },
      { src: "/images/mezcladores/mezclador-estatico-3.jpeg", label: "Mezclador Estático — fabricación en planta" },
      { src: "/images/mezcladores/mezclador-estatico-4.png", label: "Mezclador Estático — instalación en campo" },
    ],
    modelPoster: null,
  },
];

export const getProductBySlug = (slug) =>
  products.find((p) => p.id === slug) || null;
